import { render } from "./business_partner.vue?vue&type=template&id=68e046c1&scoped=true"
import script from "./business_partner.vue?vue&type=script&lang=js"
export * from "./business_partner.vue?vue&type=script&lang=js"

import "./business_partner.vue?vue&type=style&index=0&id=68e046c1&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e046c1"]])

export default __exports__